import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import packageJson from '../../../package.json';
import { getEnvironment } from '../helpers';
import { environment } from './env';

export function initDatadog() {
  const { isLocalhost } = getEnvironment();
  if (isLocalhost) {
    datadogRum.init({
      applicationId: environment.VITE_APP_DATADOG_APPLICATION_ID,
      clientToken: environment.VITE_APP_DATADOG_CLIENT_TOKEN,
      site: 'datadoghq.eu',
      service: environment.VITE_APP_ID,
      env: environment.VITE_APP_ENV,
      version: packageJson.version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin({ router: true })],
    });
  }
}
